import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PUBLIC_LEGAL_ROUTES, type PublicLegalRouteKey } from '../routes'
import './public-legal.css'

export default function PublicLegalFooter() {
  const { t } = useTranslation('legal')

  const links: { key: PublicLegalRouteKey; label: string }[] = [
    { key: 'privacy', label: t('footer.privacy') },
    { key: 'terms', label: t('footer.terms') },
    { key: 'refund', label: t('footer.refund') },
    { key: 'billing', label: t('footer.billing') },
  ]

  return (
    <footer className="pub-legal-footer">
      <div className="pub-legal-footer-inner">
        <div className="pub-legal-footer-col">
          <div className="pub-legal-footer-heading">{t('footer.legalHeading')}</div>
          <nav className="pub-legal-footer-links" aria-label={t('shell.legalNavLabel')}>
            {links.map((item) => (
              <Link key={item.key} to={PUBLIC_LEGAL_ROUTES[item.key]} rel="noopener noreferrer">
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
        <div className="pub-legal-footer-meta">© {new Date().getFullYear()} Vistoera</div>
      </div>
    </footer>
  )
}
